// mock-challenge-builder-project.nested-and-flat.ts
// Rules satisfied:
// - IDs: obj1.., task1.., targ1..
// - cycleLength = 7
// - each task.schedule length = 7, values only: morning | afternoon | evening | night | multiple
// - objectives[] has nested tasks[], each task has nested metrics[], each metric has nested target
// - ALSO: tasks[], metrics[], targets[] are flattened and contain the SAME data as in the nested objectives

import {ChallengeBuilderProject} from '../model/project'; // adjust path
import {TrackerMetricTypes} from 'src/app/trackers/shared/tracker-metric-types';

export const cbMock: ChallengeBuilderProject = {
  _id: '697ed74b4b117dd1d0a3db65',
  challengeBuilder: {
    initialGoal: 'Get some goals in place.',

    goals: [
      {
        name: 'Goal 1 for the challenge builder project to test the length of the goal text in the footer button  Goal 1 for the challenge builder project to test the length of the goal text in the footer button Goal 1 for the challenge builder project to test the length of the goal text in the footer button ',
        selected: true,
      },
      {name: 'Goal 2', selected: false},
      {name: 'Goal 3', selected: false},
    ],

    // ✅ NESTED objectives -> tasks -> metrics -> target
    objectives: [
      {
        _id: 'obj1',
        name: 'Objective 1',
        selected: true,
        tasks: [
          {
            _id: 'task1',
            name: 'Task 1',
            selected: true,
            objectiveId: 'obj1',
            schedule: ['morning', 'morning', 'afternoon', 'afternoon', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met1',
                name: 'Metric 1',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task1',
                target: {
                  targetName: 'Target 1',
                  targetValue: 10,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task1',
                  metricId: 'met1',
                  // interface requires targetMetric; keeping as minimal placeholder
                  targetMetric: {trackerId: 'trk1', metricId: 'met1'},
                },
              },
              {
                _id: 'met2',
                name: 'Metric 2',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task1',
                target: {
                  targetName: 'Target 2',
                  targetValue: 1,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task1',
                  metricId: 'met2',
                  targetMetric: {trackerId: 'trk1', metricId: 'met2'},
                },
              },
            ],
          },
          {
            _id: 'task2',
            name: 'Task 2',
            selected: true,
            objectiveId: 'obj1',
            schedule: ['afternoon', 'afternoon', 'evening', 'evening', 'night', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met3',
                name: 'Metric 3',
                type: TrackerMetricTypes.Duration,
                typeOption: 'min',
                taskId: 'task2',
                target: {
                  targetName: 'Target 3',
                  targetValue: 1200, // 20 minutes in seconds
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task2',
                  metricId: 'met3',
                  targetMetric: {trackerId: 'trk2', metricId: 'met3'},
                },
              },
              {
                _id: 'met4',
                name: 'Metric 4',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'stepper',
                taskId: 'task2',
                target: {
                  targetName: 'Target 4',
                  targetValue: 5,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task2',
                  metricId: 'met4',
                  targetMetric: {trackerId: 'trk2', metricId: 'met4'},
                },
              },
            ],
          },
          {
            _id: 'task3',
            name: 'Task 3',
            selected: true,
            objectiveId: 'obj1',
            schedule: ['night', 'night', 'night', 'evening', 'evening', 'afternoon', 'multiple'],
            metrics: [
              {
                _id: 'met5',
                name: 'Metric 5',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'pages',
                taskId: 'task3',
                target: {
                  targetName: 'Target 5',
                  targetValue: 1,
                  targetOperator: 'gte',
                  targetPeriod: 'week',
                  taskId: 'task3',
                  metricId: 'met5',
                  targetMetric: {trackerId: 'trk3', metricId: 'met5'},
                },
              },
              {
                _id: 'met6',
                name: 'Metric 6',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task3',
                target: {
                  targetName: 'Target 6',
                  targetValue: 1,
                  targetOperator: 'gte',
                  targetPeriod: 'week',
                  taskId: 'task3',
                  metricId: 'met6',
                  targetMetric: {trackerId: 'trk3', metricId: 'met6'},
                },
              },
            ],
          },
        ],
      },

      {
        _id: 'obj2',
        name: 'Objective 2',
        selected: true,
        tasks: [
          {
            _id: 'task4',
            name: 'Task 4',
            selected: true,
            objectiveId: 'obj2',
            schedule: ['morning', 'afternoon', 'evening', 'night', 'morning', 'afternoon', 'multiple'],
            metrics: [
              {
                _id: 'met7',
                name: 'Metric 7',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'range',
                taskId: 'task4',
                target: {
                  targetName: 'Target 7',
                  targetValue: 7,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task4',
                  metricId: 'met7',
                  targetMetric: {trackerId: 'trk4', metricId: 'met7'},
                },
              },
              {
                _id: 'met8',
                name: 'Metric 8',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task4',
                target: {
                  targetName: 'Target 8',
                  targetValue: 1,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task4',
                  metricId: 'met8',
                  targetMetric: {trackerId: 'trk4', metricId: 'met8'},
                },
              },
            ],
          },
          {
            _id: 'task5',
            name: 'Task 5',
            selected: true,
            objectiveId: 'obj2',
            schedule: ['evening', 'evening', 'night', 'night', 'afternoon', 'morning', 'multiple'],
            metrics: [
              {
                _id: 'met9',
                name: 'Metric 9',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task5',
                target: {
                  targetName: 'Target 9',
                  targetValue: 3,
                  targetOperator: 'gte',
                  targetPeriod: 'week',
                  taskId: 'task5',
                  metricId: 'met9',
                  targetMetric: {trackerId: 'trk5', metricId: 'met9'},
                },
              },
              {
                _id: 'met10',
                name: 'Metric 10',
                type: TrackerMetricTypes.Duration,
                typeOption: 'min',
                taskId: 'task5',
                target: {
                  targetName: 'Target 10',
                  targetValue: 900, // 15 minutes in seconds
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task5',
                  metricId: 'met10',
                  targetMetric: {trackerId: 'trk5', metricId: 'met10'},
                },
              },
            ],
          },
          {
            _id: 'task6',
            name: 'Task 6',
            selected: true,
            objectiveId: 'obj2',
            schedule: ['morning', 'morning', 'morning', 'afternoon', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met11',
                name: 'Metric 11',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task6',
                target: {
                  targetName: 'Target 11',
                  targetValue: 1,
                  targetOperator: 'gte',
                  targetPeriod: 'week',
                  taskId: 'task6',
                  metricId: 'met11',
                  targetMetric: {trackerId: 'trk6', metricId: 'met11'},
                },
              },
              {
                _id: 'met12',
                name: 'Metric 12',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'stepper',
                taskId: 'task6',
                target: {
                  targetName: 'Target 12',
                  targetValue: 4,
                  targetOperator: 'gte',
                  targetPeriod: 'week',
                  taskId: 'task6',
                  metricId: 'met12',
                  targetMetric: {trackerId: 'trk6', metricId: 'met12'},
                },
              },
            ],
          },
        ],
      },

      {
        _id: 'obj3',
        name: 'Objective 3',
        selected: true,
        tasks: [
          {
            _id: 'task7',
            name: 'Task 7',
            selected: true,
            objectiveId: 'obj3',
            schedule: ['night', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met13',
                name: 'Metric 13',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task7',
                target: {
                  targetName: 'Target 13',
                  targetValue: 2,
                  targetOperator: 'gte',
                  targetPeriod: 'day',
                  taskId: 'task7',
                  metricId: 'met13',
                  targetMetric: {trackerId: 'trk7', metricId: 'met13'},
                },
              },
              {
                _id: 'met14',
                name: 'Metric 14',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task7',
                target: {
                  targetName: 'Target 14',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task7',
                  metricId: 'met14',
                  targetMetric: {trackerId: 'trk7', metricId: 'met14'},
                },
              },
            ],
          },
          {
            _id: 'task8',
            name: 'Task 8',
            selected: true,
            objectiveId: 'obj3',
            schedule: ['morning', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met15',
                name: 'Metric 15',
                type: TrackerMetricTypes.Duration,
                typeOption: 'min',
                taskId: 'task8',
                target: {
                  targetName: 'Target 15',
                  targetValue: 600, // 10 minutes in seconds
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task8',
                  metricId: 'met15',
                  targetMetric: {trackerId: 'trk8', metricId: 'met15'},
                },
              },
              {
                _id: 'met16',
                name: 'Metric 16',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'number',
                taskId: 'task8',
                target: {
                  targetName: 'Target 16',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'week',
                  taskId: 'task8',
                  metricId: 'met16',
                  targetMetric: {trackerId: 'trk8', metricId: 'met16'},
                },
              },
            ],
          },
          {
            _id: 'task9',
            name: 'Task 9',
            selected: true,
            objectiveId: 'obj3',
            schedule: ['evening', 'evening', 'evening', 'night', 'night', 'morning', 'multiple'],
            metrics: [
              {
                _id: 'met17',
                name: 'Metric 17',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'miles',
                taskId: 'task9',
                target: {
                  targetName: 'Target 17',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'week',
                  taskId: 'task9',
                  metricId: 'met17',
                  targetMetric: {trackerId: 'trk9', metricId: 'met17'},
                },
              },
              {
                _id: 'met18',
                name: 'Metric 18',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'range',
                taskId: 'task9',
                target: {
                  targetName: 'Target 18',
                  targetValue: 6,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task9',
                  metricId: 'met18',
                  targetMetric: {trackerId: 'trk9', metricId: 'met18'},
                },
              },
            ],
          },
        ],
      },

      {
        _id: 'obj4',
        name: 'Objective 4',
        selected: true,
        tasks: [
          {
            _id: 'task10',
            name: 'Task 10',
            selected: true,
            objectiveId: 'obj4',
            schedule: ['morning', 'morning', 'afternoon', 'afternoon', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met19',
                name: 'Metric 19',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task10',
                target: {
                  targetName: 'Target 19',
                  targetValue: 4,
                  targetOperator: 'lte',
                  targetPeriod: 'week',
                  taskId: 'task10',
                  metricId: 'met19',
                  targetMetric: {trackerId: 'trk10', metricId: 'met19'},
                },
              },
              {
                _id: 'met20',
                name: 'Metric 20',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task10',
                target: {
                  targetName: 'Target 20',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task10',
                  metricId: 'met20',
                  targetMetric: {trackerId: 'trk10', metricId: 'met20'},
                },
              },
            ],
          },
          {
            _id: 'task11',
            name: 'Task 11',
            selected: true,
            objectiveId: 'obj4',
            schedule: ['afternoon', 'afternoon', 'morning', 'morning', 'night', 'evening', 'multiple'],
            metrics: [
              {
                _id: 'met21',
                name: 'Metric 21',
                type: TrackerMetricTypes.Duration,
                typeOption: 'min',
                taskId: 'task11',
                target: {
                  targetName: 'Target 21',
                  targetValue: 1800, // 30 minutes in seconds
                  targetOperator: 'lte',
                  targetPeriod: 'week',
                  taskId: 'task11',
                  metricId: 'met21',
                  targetMetric: {trackerId: 'trk11', metricId: 'met21'},
                },
              },
              {
                _id: 'met22',
                name: 'Metric 22',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task11',
                target: {
                  targetName: 'Target 22',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'week',
                  taskId: 'task11',
                  metricId: 'met22',
                  targetMetric: {trackerId: 'trk11', metricId: 'met22'},
                },
              },
            ],
          },
          {
            _id: 'task12',
            name: 'Task 12',
            selected: true,
            objectiveId: 'obj4',
            schedule: ['night', 'night', 'evening', 'evening', 'afternoon', 'afternoon', 'multiple'],
            metrics: [
              {
                _id: 'met23',
                name: 'Metric 23',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'stepper',
                taskId: 'task12',
                target: {
                  targetName: 'Target 23',
                  targetValue: 8,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task12',
                  metricId: 'met23',
                  targetMetric: {trackerId: 'trk12', metricId: 'met23'},
                },
              },
              {
                _id: 'met24',
                name: 'Metric 24',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'times',
                taskId: 'task12',
                target: {
                  targetName: 'Target 24',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task12',
                  metricId: 'met24',
                  targetMetric: {trackerId: 'trk12', metricId: 'met24'},
                },
              },
            ],
          },
        ],
      },

      {
        _id: 'obj5',
        name: 'Objective 5',
        selected: true,
        tasks: [
          {
            _id: 'task13',
            name: 'Task 13',
            selected: true,
            objectiveId: 'obj5',
            schedule: ['morning', 'afternoon', 'evening', 'night', 'morning', 'afternoon', 'multiple'],
            metrics: [
              {
                _id: 'met25',
                name: 'Metric 25',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'basic',
                taskId: 'task13',
                target: {
                  targetName: 'Target 25',
                  targetValue: 12,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task13',
                  metricId: 'met25',
                  targetMetric: {trackerId: 'trk13', metricId: 'met25'},
                },
              },
              {
                _id: 'met26',
                name: 'Metric 26',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task13',
                target: {
                  targetName: 'Target 26',
                  targetValue: 1,
                  targetOperator: 'lte',
                  targetPeriod: 'day',
                  taskId: 'task13',
                  metricId: 'met26',
                  targetMetric: {trackerId: 'trk13', metricId: 'met26'},
                },
              },
            ],
          },
          {
            _id: 'task14',
            name: 'Task 14',
            selected: true,
            objectiveId: 'obj5',
            schedule: ['evening', 'evening', 'night', 'night', 'afternoon', 'morning', 'multiple'],
            metrics: [
              {
                _id: 'met27',
                name: 'Metric 27',
                type: TrackerMetricTypes.Duration,
                typeOption: 'min',
                taskId: 'task14',
                target: {
                  targetName: 'Target 27',
                  targetValue: 1500, // 25 minutes in seconds
                  targetOperator: 'eq',
                  targetPeriod: 'week',
                  taskId: 'task14',
                  metricId: 'met27',
                  targetMetric: {trackerId: 'trk14', metricId: 'met27'},
                },
              },
              {
                _id: 'met28',
                name: 'Metric 28',
                type: TrackerMetricTypes.Boolean,
                typeOption: 'times',
                taskId: 'task14',
                target: {
                  targetName: 'Target 28',
                  targetValue: 1,
                  targetOperator: 'eq',
                  targetPeriod: 'week',
                  taskId: 'task14',
                  metricId: 'met28',
                  targetMetric: {trackerId: 'trk14', metricId: 'met28'},
                },
              },
            ],
          },
          {
            _id: 'task15',
            name: 'Task 15',
            selected: true,
            objectiveId: 'obj5',
            schedule: ['night', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
            metrics: [
              {
                _id: 'met29',
                name: 'Metric 29',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'range',
                taskId: 'task15',
                target: {
                  targetName: 'Target 29',
                  targetValue: 5,
                  targetOperator: 'eq',
                  targetPeriod: 'day',
                  taskId: 'task15',
                  metricId: 'met29',
                  targetMetric: {trackerId: 'trk15', metricId: 'met29'},
                },
              },
              {
                _id: 'met30',
                name: 'Metric 30',
                type: TrackerMetricTypes.Numeric,
                typeOption: 'number',
                taskId: 'task15',
                target: {
                  targetName: 'Target 30',
                  targetValue: 1,
                  targetOperator: 'eq',
                  targetPeriod: 'day',
                  taskId: 'task15',
                  metricId: 'met30',
                  targetMetric: {trackerId: 'trk15', metricId: 'met30'},
                },
              },
            ],
          },
        ],
      },
    ],

    // ✅ FLATTENED tasks[] (same tasks as nested)
    tasks: [
      {
        _id: 'task1',
        name: 'Task 1',
        selected: true,
        objectiveId: 'obj1',
        schedule: ['morning', 'morning', 'afternoon', 'afternoon', 'evening', 'night', 'multiple'],
      },
      {
        _id: 'task2',
        name: 'Task 2',
        selected: true,
        objectiveId: 'obj1',
        schedule: ['afternoon', 'afternoon', 'evening', 'evening', 'night', 'night', 'multiple'],
      },
      {
        _id: 'task3',
        name: 'Task 3',
        selected: true,
        objectiveId: 'obj1',
        schedule: ['night', 'night', 'night', 'evening', 'evening', 'afternoon', 'multiple'],
      },

      {
        _id: 'task4',
        name: 'Task 4',
        selected: true,
        objectiveId: 'obj2',
        schedule: ['morning', 'afternoon', 'evening', 'night', 'morning', 'afternoon', 'multiple'],
      },
      {
        _id: 'task5',
        name: 'Task 5',
        selected: true,
        objectiveId: 'obj2',
        schedule: ['evening', 'evening', 'night', 'night', 'afternoon', 'morning', 'multiple'],
      },
      {
        _id: 'task6',
        name: 'Task 6',
        selected: true,
        objectiveId: 'obj2',
        schedule: ['morning', 'morning', 'morning', 'afternoon', 'evening', 'night', 'multiple'],
      },

      {
        _id: 'task7',
        name: 'Task 7',
        selected: true,
        objectiveId: 'obj3',
        schedule: ['night', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
      },
      {
        _id: 'task8',
        name: 'Task 8',
        selected: true,
        objectiveId: 'obj3',
        schedule: ['morning', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
      },
      {
        _id: 'task9',
        name: 'Task 9',
        selected: true,
        objectiveId: 'obj3',
        schedule: ['evening', 'evening', 'evening', 'night', 'night', 'morning', 'multiple'],
      },

      {
        _id: 'task10',
        name: 'Task 10',
        selected: true,
        objectiveId: 'obj4',
        schedule: ['morning', 'morning', 'afternoon', 'afternoon', 'evening', 'night', 'multiple'],
      },
      {
        _id: 'task11',
        name: 'Task 11',
        selected: true,
        objectiveId: 'obj4',
        schedule: ['afternoon', 'afternoon', 'morning', 'morning', 'night', 'evening', 'multiple'],
      },
      {
        _id: 'task12',
        name: 'Task 12',
        selected: true,
        objectiveId: 'obj4',
        schedule: ['night', 'night', 'evening', 'evening', 'afternoon', 'afternoon', 'multiple'],
      },

      {
        _id: 'task13',
        name: 'Task 13',
        selected: true,
        objectiveId: 'obj5',
        schedule: ['morning', 'afternoon', 'evening', 'night', 'morning', 'afternoon', 'multiple'],
      },
      {
        _id: 'task14',
        name: 'Task 14',
        selected: true,
        objectiveId: 'obj5',
        schedule: ['evening', 'evening', 'night', 'night', 'afternoon', 'morning', 'multiple'],
      },
      {
        _id: 'task15',
        name: 'Task 15',
        selected: true,
        objectiveId: 'obj5',
        schedule: ['night', 'afternoon', 'afternoon', 'evening', 'evening', 'night', 'multiple'],
      },
    ],

    // ✅ FLATTENED metrics[] (same metrics as nested; each has the same target object)
    metrics: [
      {
        _id: 'met1',
        name: 'Metric 1',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'basic',
        taskId: 'task1',
        target: {
          targetName: 'Target 1',
          targetValue: 10,
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task1',
          metricId: 'met1',
          targetMetric: {trackerId: 'trk1', metricId: 'met1'},
        },
      },
      {
        _id: 'met2',
        name: 'Metric 2',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task1',
        target: {
          targetName: 'Target 2',
          targetValue: 1,
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task1',
          metricId: 'met2',
          targetMetric: {trackerId: 'trk1', metricId: 'met2'},
        },
      },

      {
        _id: 'met3',
        name: 'Metric 3',
        type: TrackerMetricTypes.Duration,
        typeOption: 'min',
        taskId: 'task2',
        target: {
          targetName: 'Target 3',
          targetValue: 1200, // 20 minutes in seconds
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task2',
          metricId: 'met3',
          targetMetric: {trackerId: 'trk2', metricId: 'met3'},
        },
      },
      {
        _id: 'met4',
        name: 'Metric 4',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'stepper',
        taskId: 'task2',
        target: {
          targetName: 'Target 4',
          targetValue: 5,
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task2',
          metricId: 'met4',
          targetMetric: {trackerId: 'trk2', metricId: 'met4'},
        },
      },

      {
        _id: 'met5',
        name: 'Metric 5',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'pages',
        taskId: 'task3',
        target: {
          targetName: 'Target 5',
          targetValue: 1,
          targetOperator: 'eq',
          targetPeriod: 'week',
          taskId: 'task3',
          metricId: 'met5',
          targetMetric: {trackerId: 'trk3', metricId: 'met5'},
        },
      },
      {
        _id: 'met6',
        name: 'Metric 6',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'times',
        taskId: 'task3',
        target: {
          targetName: 'Target 6',
          targetValue: 1,
          targetOperator: 'eq',
          targetPeriod: 'week',
          taskId: 'task3',
          metricId: 'met6',
          targetMetric: {trackerId: 'trk3', metricId: 'met6'},
        },
      },

      {
        _id: 'met7',
        name: 'Metric 7',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'range',
        taskId: 'task4',
        target: {
          targetName: 'Target 7',
          targetValue: 7,
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task4',
          metricId: 'met7',
          targetMetric: {trackerId: 'trk4', metricId: 'met7'},
        },
      },
      {
        _id: 'met8',
        name: 'Metric 8',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task4',
        target: {
          targetName: 'Target 8',
          targetValue: 1,
          targetOperator: 'eq',
          targetPeriod: 'day',
          taskId: 'task4',
          metricId: 'met8',
          targetMetric: {trackerId: 'trk4', metricId: 'met8'},
        },
      },

      {
        _id: 'met9',
        name: 'Metric 9',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'basic',
        taskId: 'task5',
        target: {
          targetName: 'Target 9',
          targetValue: 3,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task5',
          metricId: 'met9',
          targetMetric: {trackerId: 'trk5', metricId: 'met9'},
        },
      },
      {
        _id: 'met10',
        name: 'Metric 10',
        type: TrackerMetricTypes.Duration,
        typeOption: 'min',
        taskId: 'task5',
        target: {
          targetName: 'Target 10',
          targetValue: 900, // 15 minutes in seconds
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task5',
          metricId: 'met10',
          targetMetric: {trackerId: 'trk5', metricId: 'met10'},
        },
      },

      {
        _id: 'met11',
        name: 'Metric 11',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task6',
        target: {
          targetName: 'Target 11',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task6',
          metricId: 'met11',
          targetMetric: {trackerId: 'trk6', metricId: 'met11'},
        },
      },
      {
        _id: 'met12',
        name: 'Metric 12',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'stepper',
        taskId: 'task6',
        target: {
          targetName: 'Target 12',
          targetValue: 4,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task6',
          metricId: 'met12',
          targetMetric: {trackerId: 'trk6', metricId: 'met12'},
        },
      },

      {
        _id: 'met13',
        name: 'Metric 13',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'basic',
        taskId: 'task7',
        target: {
          targetName: 'Target 13',
          targetValue: 2,
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task7',
          metricId: 'met13',
          targetMetric: {trackerId: 'trk7', metricId: 'met13'},
        },
      },
      {
        _id: 'met14',
        name: 'Metric 14',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task7',
        target: {
          targetName: 'Target 14',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task7',
          metricId: 'met14',
          targetMetric: {trackerId: 'trk7', metricId: 'met14'},
        },
      },

      {
        _id: 'met15',
        name: 'Metric 15',
        type: TrackerMetricTypes.Duration,
        typeOption: 'min',
        taskId: 'task8',
        target: {
          targetName: 'Target 15',
          targetValue: 600, // 10 minutes in seconds
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task8',
          metricId: 'met15',
          targetMetric: {trackerId: 'trk8', metricId: 'met15'},
        },
      },
      {
        _id: 'met16',
        name: 'Metric 16',
        type: TrackerMetricTypes.Percentage,
        typeOption: 'number',
        taskId: 'task8',
        target: {
          targetName: 'Target 16',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task8',
          metricId: 'met16',
          targetMetric: {trackerId: 'trk8', metricId: 'met16'},
        },
      },

      {
        _id: 'met17',
        name: 'Metric 17',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'miles',
        taskId: 'task9',
        target: {
          targetName: 'Target 17',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task9',
          metricId: 'met17',
          targetMetric: {trackerId: 'trk9', metricId: 'met17'},
        },
      },
      {
        _id: 'met18',
        name: 'Metric 18',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'range',
        taskId: 'task9',
        target: {
          targetName: 'Target 18',
          targetValue: 6,
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task9',
          metricId: 'met18',
          targetMetric: {trackerId: 'trk9', metricId: 'met18'},
        },
      },

      {
        _id: 'met19',
        name: 'Metric 19',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'basic',
        taskId: 'task10',
        target: {
          targetName: 'Target 19',
          targetValue: 4,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task10',
          metricId: 'met19',
          targetMetric: {trackerId: 'trk10', metricId: 'met19'},
        },
      },
      {
        _id: 'met20',
        name: 'Metric 20',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task10',
        target: {
          targetName: 'Target 20',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'day',
          taskId: 'task10',
          metricId: 'met20',
          targetMetric: {trackerId: 'trk10', metricId: 'met20'},
        },
      },

      {
        _id: 'met21',
        name: 'Metric 21',
        type: TrackerMetricTypes.Duration,
        typeOption: 'min',
        taskId: 'task11',
        target: {
          targetName: 'Target 21',
          targetValue: 1800, // 30 minutes in seconds
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task11',
          metricId: 'met21',
          targetMetric: {trackerId: 'trk11', metricId: 'met21'},
        },
      },
      {
        _id: 'met22',
        name: 'Metric 22',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task11',
        target: {
          targetName: 'Target 22',
          targetValue: 1,
          targetOperator: 'gte',
          targetPeriod: 'week',
          taskId: 'task11',
          metricId: 'met22',
          targetMetric: {trackerId: 'trk11', metricId: 'met22'},
        },
      },

      {
        _id: 'met23',
        name: 'Metric 23',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'stepper',
        taskId: 'task12',
        target: {
          targetName: 'Target 23',
          targetValue: 8,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task12',
          metricId: 'met23',
          targetMetric: {trackerId: 'trk12', metricId: 'met23'},
        },
      },
      {
        _id: 'met24',
        name: 'Metric 24',
        type: TrackerMetricTypes.Percentage,
        typeOption: 'times',
        taskId: 'task12',
        target: {
          targetName: 'Target 24',
          targetValue: 1,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task12',
          metricId: 'met24',
          targetMetric: {trackerId: 'trk12', metricId: 'met24'},
        },
      },

      {
        _id: 'met25',
        name: 'Metric 25',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'basic',
        taskId: 'task13',
        target: {
          targetName: 'Target 25',
          targetValue: 12,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task13',
          metricId: 'met25',
          targetMetric: {trackerId: 'trk13', metricId: 'met25'},
        },
      },
      {
        _id: 'met26',
        name: 'Metric 26',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task13',
        target: {
          targetName: 'Target 26',
          targetValue: 1,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task13',
          metricId: 'met26',
          targetMetric: {trackerId: 'trk13', metricId: 'met26'},
        },
      },

      {
        _id: 'met27',
        name: 'Metric 27',
        type: TrackerMetricTypes.Duration,
        typeOption: 'min',
        taskId: 'task14',
        target: {
          targetName: 'Target 27',
          targetValue: 1500, // 25 minutes in seconds
          targetOperator: 'lte',
          targetPeriod: 'week',
          taskId: 'task14',
          metricId: 'met27',
          targetMetric: {trackerId: 'trk14', metricId: 'met27'},
        },
      },
      {
        _id: 'met28',
        name: 'Metric 28',
        type: TrackerMetricTypes.Boolean,
        typeOption: 'times',
        taskId: 'task14',
        target: {
          targetName: 'Target 28',
          targetValue: 1,
          targetOperator: 'lte',
          targetPeriod: 'week',
          taskId: 'task14',
          metricId: 'met28',
          targetMetric: {trackerId: 'trk14', metricId: 'met28'},
        },
      },

      {
        _id: 'met29',
        name: 'Metric 29',
        type: TrackerMetricTypes.Numeric,
        typeOption: 'range',
        taskId: 'task15',
        target: {
          targetName: 'Target 29',
          targetValue: 5,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task15',
          metricId: 'met29',
          targetMetric: {trackerId: 'trk15', metricId: 'met29'},
        },
      },
      {
        _id: 'met30',
        name: 'Metric 30',
        type: TrackerMetricTypes.Percentage,
        typeOption: 'number',
        taskId: 'task15',
        target: {
          targetName: 'Target 30',
          targetValue: 1,
          targetOperator: 'lte',
          targetPeriod: 'day',
          taskId: 'task15',
          metricId: 'met30',
          targetMetric: {trackerId: 'trk15', metricId: 'met30'},
        },
      },
    ],

    // ✅ FLATTENED targets[] (same targets as nested)
    targets: [
      {
        _id: 'target1',
        targetName: 'Target 1',
        targetValue: 10,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task1',
        metricId: 'met1',
        targetMetric: {trackerId: 'trk1', metricId: 'met1'},
      },
      {
        _id: 'target2',
        targetName: 'Target 2',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task1',
        metricId: 'met2',
        targetMetric: {trackerId: 'trk1', metricId: 'met2'},
      },

      {
        _id: 'target3',
        targetName: 'Target 3',
        targetValue: 1200, // 20 minutes in seconds
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task2',
        metricId: 'met3',
        targetMetric: {trackerId: 'trk2', metricId: 'met3'},
      },
      {
        _id: 'target4',
        targetName: 'Target 4',
        targetValue: 5,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task2',
        metricId: 'met4',
        targetMetric: {trackerId: 'trk2', metricId: 'met4'},
      },

      {
        _id: 'target5',
        targetName: 'Target 5',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task3',
        metricId: 'met5',
        targetMetric: {trackerId: 'trk3', metricId: 'met5'},
      },
      {
        _id: 'target6',
        targetName: 'Target 6',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task3',
        metricId: 'met6',
        targetMetric: {trackerId: 'trk3', metricId: 'met6'},
      },

      {
        _id: 'target7',
        targetName: 'Target 7',
        targetValue: 7,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task4',
        metricId: 'met7',
        targetMetric: {trackerId: 'trk4', metricId: 'met7'},
      },
      {
        _id: 'target8',
        targetName: 'Target 8',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task4',
        metricId: 'met8',
        targetMetric: {trackerId: 'trk4', metricId: 'met8'},
      },

      {
        _id: 'target9',
        targetName: 'Target 9',
        targetValue: 3,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task5',
        metricId: 'met9',
        targetMetric: {trackerId: 'trk5', metricId: 'met9'},
      },
      {
        _id: 'target10',
        targetName: 'Target 10',
        targetValue: 900, // 15 minutes in seconds
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task5',
        metricId: 'met10',
        targetMetric: {trackerId: 'trk5', metricId: 'met10'},
      },

      {
        _id: 'target11',
        targetName: 'Target 11',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task6',
        metricId: 'met11',
        targetMetric: {trackerId: 'trk6', metricId: 'met11'},
      },
      {
        _id: 'target12',
        targetName: 'Target 12',
        targetValue: 4,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task6',
        metricId: 'met12',
        targetMetric: {trackerId: 'trk6', metricId: 'met12'},
      },

      {
        targetName: 'Target 13',
        targetValue: 2,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task7',
        metricId: 'met13',
        targetMetric: {trackerId: 'trk7', metricId: 'met13'},
      },
      {
        targetName: 'Target 14',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task7',
        metricId: 'met14',
        targetMetric: {trackerId: 'trk7', metricId: 'met14'},
      },

      {
        targetName: 'Target 15',
        targetValue: 600, // 10 minutes in seconds
        targetOperator: 'lte',
        targetPeriod: 'day',
        taskId: 'task8',
        metricId: 'met15',
        targetMetric: {trackerId: 'trk8', metricId: 'met15'},
      },
      {
        targetName: 'Target 16',
        targetValue: 1,
        targetOperator: 'lte',
        targetPeriod: 'week',
        taskId: 'task8',
        metricId: 'met16',
        targetMetric: {trackerId: 'trk8', metricId: 'met16'},
      },

      {
        targetName: 'Target 17',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task9',
        metricId: 'met17',
        targetMetric: {trackerId: 'trk9', metricId: 'met17'},
      },
      {
        targetName: 'Target 18',
        targetValue: 6,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task9',
        metricId: 'met18',
        targetMetric: {trackerId: 'trk9', metricId: 'met18'},
      },

      {
        targetName: 'Target 19',
        targetValue: 4,
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task10',
        metricId: 'met19',
        targetMetric: {trackerId: 'trk10', metricId: 'met19'},
      },
      {
        targetName: 'Target 20',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task10',
        metricId: 'met20',
        targetMetric: {trackerId: 'trk10', metricId: 'met20'},
      },

      {
        targetName: 'Target 21',
        targetValue: 1800, // 30 minutes in seconds
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task11',
        metricId: 'met21',
        targetMetric: {trackerId: 'trk11', metricId: 'met21'},
      },
      {
        targetName: 'Target 22',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task11',
        metricId: 'met22',
        targetMetric: {trackerId: 'trk11', metricId: 'met22'},
      },

      {
        targetName: 'Target 23',
        targetValue: 8,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task12',
        metricId: 'met23',
        targetMetric: {trackerId: 'trk12', metricId: 'met23'},
      },
      {
        targetName: 'Target 24',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task12',
        metricId: 'met24',
        targetMetric: {trackerId: 'trk12', metricId: 'met24'},
      },

      {
        targetName: 'Target 25',
        targetValue: 12,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task13',
        metricId: 'met25',
        targetMetric: {trackerId: 'trk13', metricId: 'met25'},
      },
      {
        targetName: 'Target 26',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task13',
        metricId: 'met26',
        targetMetric: {trackerId: 'trk13', metricId: 'met26'},
      },

      {
        targetName: 'Target 27',
        targetValue: 1500, // 25 minutes in seconds
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task14',
        metricId: 'met27',
        targetMetric: {trackerId: 'trk14', metricId: 'met27'},
      },
      {
        targetName: 'Target 28',
        targetValue: 1,
        targetOperator: 'eq',
        targetPeriod: 'week',
        taskId: 'task14',
        metricId: 'met28',
        targetMetric: {trackerId: 'trk14', metricId: 'met28'},
      },

      {
        targetName: 'Target 29',
        targetValue: 5,
        targetOperator: 'eq',
        targetPeriod: 'day',
        taskId: 'task15',
        metricId: 'met29',
        targetMetric: {trackerId: 'trk15', metricId: 'met29'},
      },
      {
        targetName: 'Target 30',
        targetValue: 1,
        targetOperator: 'gte',
        targetPeriod: 'day',
        taskId: 'task15',
        metricId: 'met30',
        targetMetric: {trackerId: 'trk15', metricId: 'met30'},
      },
    ],

    salvages: [
      {_id: 'salvage1', name: 'Salvage 1', targetId: 'target1'},
      {_id: 'salvage2', name: 'Salvage 2', targetId: 'target2'},
      {_id: 'salvage3', name: 'Salvage 3', targetId: 'target3'},
      {_id: 'salvage4', name: 'Salvage 4', targetId: 'target4'},
      {_id: 'salvage5', name: 'Salvage 5', targetId: 'target5'},
      {_id: 'salvage6', name: 'Salvage 6', targetId: 'target6'},
    ],

    rewards: [
      {name: 'Reward 1', description: 'Reward description 1', rewardCost: 1},
      {name: 'Reward 2', description: 'Reward description 2', rewardCost: 2},
      {name: 'Reward 3', description: 'Reward description 3', rewardCost: 3},
      {name: 'Reward 4', description: 'Reward description 4', rewardCost: 4},
      {name: 'Reward 5', description: 'Reward description 5', rewardCost: 5},
      {name: 'Reward 6', description: 'Reward description 6', rewardCost: 6},
    ],

    alerts: [
      {_id: 'alert1', days: [0, 2, 4], time: '2026-02-03T13:00:00.000Z', message: 'Alert 1', active: true},
      {_id: 'alert2', days: [1, 3, 5], time: '2026-02-03T18:00:00.000Z', message: 'Alert 2', active: true},
      {_id: 'alert3', days: [0, 1, 2, 3, 4, 5, 6], time: '2026-02-03T02:00:00.000Z', message: 'Alert 3', active: false},
      {_id: 'alert4', days: [6], time: '2026-02-03T21:30:00.000Z', message: 'Alert 4', active: true},
    ],
  },
};
